import React, { useState } from 'react'
import { client, images } from '../../utilities'
import motionWrapper from '../../utilities/MotionWrapper'

import wrapper from '../../utilities/Wrapper'
import './Footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    message: '',
  })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { username, email, message } = formData

  const handleChangeInput = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = () => {
    const contact = {
      _type: 'contact',
      name: username,
      email: email,
      message: message,
    }
    if (contact.name && contact.email && contact.message) {
      setLoading(true)
      client
        .create(contact)
        .then(() => {
          setLoading(false)
          setIsFormSubmitted(true)

          setTimeout(() => {
            setIsFormSubmitted(false)
            setFormData({ username: '', email: '', message: '' })
          }, 3000)
        })
        .catch(err => console.log(err))
    } else {
      alert('please enter a valid information!')
    }
  }

  return (
    <>
      <h2 className='head-text'>Take a coffee & chat with me</h2>

      <div className='app__footer-cards'>
        <div className='app__footer-card bg-[#fef4f5] dark:bg-slate-600 dark:hover:shadow-[0_0_20px_#585858] dark:hover:bg-slate-800'>
          <img src={images.email} alt='email' />
          <a
            href='mailto:tahaebaed7@gmail.com'
            className='p-text dark:text-white'
          >
            tahaebaed7@gmail.com
          </a>
        </div>
        <div className='app__footer-card bg-white dark:bg-slate-400 dark:hover:shadow-[0_0_20px_#585858] dark:hover:bg-slate-800'>
          <img src={images.mobile} alt='phone' />
          <a href='tel:+201007727196' className='p-text dark:text-white'>
            +20 (100) 772-7196
          </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className='app__footer-form app__flex'>
          <div className='app__flex dark:bg-black dark:hover:shadow-[0_0_20px_#585858]'>
            <input
              className='p-text dark:bg-slate-800 dark:placeholder:text-white dark:text-white'
              type='text'
              placeholder='Your Name'
              name='username'
              value={username}
              onChange={handleChangeInput}
            />
          </div>
          <div className='app__flex dark:hover:shadow-[0_0_20px_#585858] dark:bg-black'>
            <input
              className='p-text dark:bg-slate-800 dark:hover:shadow-[0_0_20px_#585858] dark:placeholder:text-white dark:text-white'
              type='email'
              autoComplete='email-example'
              placeholder='Your Email'
              name='email'
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div className='dark:bg-black dark:hover:shadow-[0_0_20px_#585858]'>
            <textarea
              className='p-text dark:bg-slate-800 dark:hover:shadow-[0_0_20px_#585858] dark:placeholder:text-white dark:text-white'
              placeholder='Your Message'
              value={message}
              name='message'
              onChange={handleChangeInput}
            />
          </div>
          <button
            type='button'
            className='p-text dark:bg-slate-600 dark:hover:bg-slate-800'
            onClick={handleSubmit}
          >
            {!loading ? 'Send Message' : 'Sending...'}
          </button>
        </div>
      ) : (
        <div>
          <h3 className='head-text dark:text-slate-300'>
            Thank you for getting in touch!
          </h3>
        </div>
      )}
    </>
  )
}

export default wrapper(
  motionWrapper(Footer, 'app__footer'),
  'contact',
  'app__whitebg dark:bg-black'
)
